import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Label from 'components/form/Label';
import Button from 'components/form/Button';
import InputOTP from 'components/form/InputOTP';
import TextInput from 'components/form/TextInput';
import PasswordInput from 'components/form/PasswordInput';
import Card from 'components/Layout/Card';
// import Loader from "components/Layout/Loader";
import HeaderLayout from 'components/Layout/HeaderLayout';
import LineTextLabel from 'components/Layout/LineTextLabel';
import {
  forgotPassword,
  handelMemberLogin,
  sendForgotPasswordLink,
  setApiError,
} from 'store/slices';
import {
  convertString,
  formatTime,
  getCountryCode,
  getUserType,
  numberOnlyFromInput,
  objectToFormData,
} from 'utils/helpers';
import { dialCode, icons } from 'utils/constants';
import axios from 'axios';
import { useGoogleLogin } from '@react-oauth/google';
import './ForgotPassword.scss';

const ForgotPassword = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();

  const [counter, setCounter] = useState(600);
  const [otpLoader, setOtpLoader] = useState(false);
  const [loadButton, setLoadButton] = useState(false);
  const [resetOTP, setResetOTP] = useState(true);
  const [formType, setFormType] = useState(0);
  const [emailId, setEmailId] = useState('');
  const [userID, setUserID] = useState('');
  const [otp, setOTP] = useState('');
  const [isOTPSent, setIsOTPSent] = useState(false);
  const [isGoggleBtnLoad, setIsGoggleBtnLoad] = useState(false);
  const [verifyLoader, setVerifyLoader] = useState(false);
  const [authAction, setAuthAction] = useState('');

  const [selectedMethod, setSelectedMethod] = useState(null);
  const [whatsappData, setWhatsappData] = useState({});

  const initialValues = {
    selectedMethod: null,
    email: '',
    whatsapp_number: '',
    country_code: 'IN',
    mobile_no_length: 10,
    new_password: '',
    confirm_password: '',
  };
  const validationSchema = Yup.object().shape({
    email: Yup.lazy(() => {
      if (formType === 2) {
        return Yup.string();
      } else {
        return Yup.string()
          .required('Email is required.')
          .email('Email must be a valid email');
      }
    }),
    whatsapp_number: Yup.string().when('selectedMethod', {
      is: 'whatsapp', // ✅ only validate if method is whatsapp
      then: Yup.lazy((_, obj) => {
        const { country_code, mobile_no_length } = obj?.parent || {};

        if (country_code === 'IN' && mobile_no_length) {
          const validLengths = Array.isArray(mobile_no_length)
            ? mobile_no_length
            : [mobile_no_length];

          return Yup.string()
            .required('Whatsapp number is required.')
            .test(
              'valid-length',
              `Whatsapp number must be ${validLengths.join(' or ')} digits.`,
              (value) => value && validLengths.includes(value.length)
            );
        } else {
          return Yup.string()
            .required('Whatsapp number is required.')
            .min(8, 'Whatsapp number must be at least 8 digits.')
            .max(15, 'Whatsapp number must be at most 15 digits.');
        }
      }),
      otherwise: Yup.string().nullable(), // ✅ skip validation if not whatsapp
    }),

    new_password: Yup.lazy(() => {
      if (formType === 2) {
        return Yup.string()
          .required('New password is required.')
          .min(6, 'Password must be at least 6 characters.')
          .max(16, 'Password must be at most 16 characters.')
          .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{6,16}$/,
            'Password was not strong.'
          );
        // .matches(
        //   /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,16}$/,
        //   'Password was not strong.'
        // );
      } else {
        return Yup.string();
      }
    }),
    confirm_password: Yup.lazy(() => {
      if (formType === 2) {
        return Yup.string()
          .required('Confirm password is required.')
          .oneOf([Yup.ref('new_password'), null], 'Password not matched.');
      } else {
        return Yup.string();
      }
    }),
  });
  const handelVerifyOTP = async () => {
    setLoadButton(true);
    const formData = objectToFormData({
      type: 2,
      id: userID,
      otp: otp,
    });
    const response = await dispatch(forgotPassword(formData));
    if (response?.status === 200) {
      dispatch(
        setApiError({
          show: true,
          message: 'OTP Verified Successfully.',
          type: 'success',
        })
      );

      setFormType(2);
    }
    setLoadButton(false);
  };

  const handelSendOTP = async (values) => {
    if (authAction === 'otp') {
      setOtpLoader(true);
      const formData = objectToFormData({
        type: 1,
        email_or_phone: values?.email,
        phone_no: values?.whatsapp_number,
        country_code: values?.country_code,
        send_via: selectedMethod === 'whatsapp' ? 2 : 1, // 1 for email, 2 for whatsapp
      });
      const response = await dispatch(forgotPassword(formData));
      if (response?.status === 200) {
        setEmailId(values?.email);
        setIsOTPSent(true);
        setCounter(600);
        dispatch(
          setApiError({
            show: true,
            message: 'OTP Send Successfully.',
            type: 'success',
          })
        );
        setResetOTP(true);
        setUserID(response.data.id);
        setFormType(1);
      }
      setOtpLoader(false);
    } else if (authAction === 'link') {
      setEmailId(values?.email);
      setFormType(3);
    }
  };

  const handelWhatsappSendOTP = async (values) => {
    if (authAction === 'otp') {
      setOtpLoader(true);
      const formData = objectToFormData({
        type: 1,
        email_or_phone: values?.email,
        phone_no: values?.whatsapp_number,
        country_code: values?.country_code,
        send_via: 2, // 1 for email, 2 for whatsapp
      });
      const response = await dispatch(forgotPassword(formData));
      if (response?.status === 200) {
        setWhatsappData(values);
        setIsOTPSent(true);
        setCounter(600);
        dispatch(
          setApiError({
            show: true,
            message: 'OTP Send Successfully.',
            type: 'success',
          })
        );
        setResetOTP(true);
        setUserID(response.data.id);
        setFormType(1);
      }
      setOtpLoader(false);
    } else if (authAction === 'link') {
      setWhatsappData(values);
      setFormType(3);
    }
  };

  const login = useGoogleLogin({
    onSuccess: async (response) => {
      setIsGoggleBtnLoad(true);
      const data = await axios.get(
        'https://www.googleapis.com/oauth2/v3/userinfo',
        {
          headers: {
            Authorization: `Bearer ${response.access_token}`,
          },
        }
      );
      if (data?.status === 200) {
        // const token = await getToken();
        const token = '';
        let forData = objectToFormData({
          email_or_phone: data?.data?.email,
          google_id: data?.data?.sub,
          profile_photo_path: data?.data?.picture,
          firebase_token: token,
        });
        await dispatch(handelMemberLogin(forData));
        if (state?.redirectRoute && state?.redirectRoute !== '/') {
          let splitedData = state?.redirectRoute?.split('/');
          if (
            splitedData?.[2] === 'dashboard' &&
            splitedData?.[3] === undefined
          ) {
            navigate('/', {
              replace: true,
              state: {
                redirectRoute: '',
              },
            });
          } else {
            const findType = getUserType(response?.data?.user_type);
            let redirectURL = state?.redirectRoute;
            if (splitedData[1] !== findType) {
              redirectURL = redirectURL.replace(splitedData[1], findType);
            }
            navigate(redirectURL, {
              state: {
                redirectRoute: '',
              },
            });
            window.location.reload();
          }
        }
      }
      setIsGoggleBtnLoad(false);
    },
  });
  const handleOtp = (newOtp) => {
    if (newOtp) {
      setOTP(newOtp);
    }
  };
  const handelChangePassword = async (values) => {
    setLoadButton(true);
    const formData = objectToFormData({
      type: 3,
      id: userID,
      ...values,
    });
    const response = await dispatch(forgotPassword(formData));
    if (response?.status === 200) {
      dispatch(
        setApiError({
          show: true,
          message: 'Password changed Successfully.',
          type: 'success',
        })
      );
      setTimeout(() => {
        navigate(`/${params.type}/login`);
      }, 2000);
    }
    setLoadButton(false);
  };
  // countdown timer
  useEffect(() => {
    if (counter > 0) {
      const timer = setTimeout(() => setCounter(counter - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      setIsOTPSent(false);
    }
  }, [counter]);

  useEffect(() => {
    setResetOTP(true);
    if (formType === 1) {
      setOTP('');
    }
  }, [formType]);

  const handleVerifyLink = async () => {
    setVerifyLoader(true);

    const payload = {
      send_via: selectedMethod === 'whatsapp' ? 2 : 1,
      email_or_phone:
        selectedMethod === 'whatsapp' ? whatsappData?.email : emailId,

      ...(selectedMethod === 'whatsapp' && {
        phone_no: whatsappData?.whatsapp_number,
        country_code: whatsappData?.country_code,
      }),
    };

    const formData = objectToFormData(payload);

    const response = await dispatch(sendForgotPasswordLink(formData));
    if (response?.status === 200) {
      dispatch(
        setApiError({
          show: true,
          message: response?.message,
          type: 'success',
        })
      );
    }
    setVerifyLoader(false);
  };

  const handleSelectMethod = (method, setFieldValue) => {
    setFieldValue('selectedMethod', method);
    setSelectedMethod(method);
  };

  const handleSendOtp = (values, step) => {
    setFormType(step);
    setWhatsappData(values);
  };

  return (
    <HeaderLayout>
      <div id="forgot-password-container">
        <Card className="card-padding ps-5 pe-5 pt-5 pb-5">
          <div className="d-flex center-flex position-relative mb-5">
            <span
              className="d-flex position-absolute start-0"
              onClick={() => {
                formType === 0 ? navigate(-1) : setFormType(0);

                // formType === 1
                // ? setFormType(0)
                // : authAction === 'link'
                // ? setFormType(0)
                // : setFormType(1);
              }}
            >
              <img
                src={icons.leftArrow}
                alt="back"
                className="h-21 me-3 pointer"
              />
            </span>
            <div className="text-28-500 color-black-olive">
              {formType === 0
                ? 'Reset Password'
                : formType === 1 || 3 || 4
                  ? `${selectedMethod === 'whatsapp' ? 'Whatsapp' : 'Email'
                  } Verification`
                  : 'New Password'}
            </div>
          </div>
          {/* Main Form */}
          {formType === 0 && (
            <Formik
              enableReinitialize
              initialValues={initialValues}
              onSubmit={async (values) => {
                handelSendOTP(values);
              }}
              validationSchema={validationSchema}
            >
              {(props) => {
                const {
                  values,
                  errors,
                  handleChange,
                  handleSubmit,
                  setFieldValue,
                } = props;
                const { selectedMethod } = values;
                return (
                  <form
                    onSubmit={handleSubmit}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        handleSubmit();
                      }
                    }}
                  >
                    {selectedMethod && (
                      <p className="text-16-400 color-black-olive cmb-11 text-center px-0 px-md-5">
                        {`Choose how you would like to verify your account on ${selectedMethod}`}
                      </p>
                    )}

                    <div className="mb-4">
                      <TextInput
                        id="email"
                        label="Email ID"
                        labelClass="mb-2"
                        placeholder="Enter email"
                        value={values.email}
                        error={errors.email}
                        onChange={(e) => {
                          handleChange(convertString(1, e));
                        }}
                        disabled={selectedMethod}
                      />
                    </div>

                    {selectedMethod === 'whatsapp' && (
                      <div className="mb-4">
                        <TextInput
                          isPhoneNumber
                          type="number"
                          id="whatsapp_number"
                          placeholder="Whatsapp Number"
                          value={values.whatsapp_number}
                          // error={errors.whatsapp_number}
                          error={errors.whatsapp_number}
                          phoneNumberData={{
                            id: 'country_code',
                            value: values.country_code,
                          }}
                          onChange={(e) => {
                            if (e.target.id === 'whatsapp_number') {
                              handleChange(numberOnlyFromInput(e));
                            } else {
                              handleChange(e);
                              handleChange({
                                target: { id: 'whatsapp_number', value: '' },
                              });
                              setFieldValue(
                                'mobile_no_length',
                                e.target.length
                              );
                            }
                          }}
                        />
                      </div>
                    )}

                    {selectedMethod ? (
                      <div className="d-flex gap-3 mb-5 w-100">
                        <div style={{ flex: '0 0 40%' }}>
                          <Button
                            text="Send OTP"
                            btnStyle="primary-dark"
                            onClick={() => {
                              setAuthAction('otp');
                              selectedMethod === 'whatsapp'
                                ? handleSendOtp(values, 4)
                                : handleSubmit();
                            }}
                            disabled={otpLoader}
                            btnLoading={otpLoader}
                            className="h-35 w-100"
                          />
                        </div>
                        <div style={{ flex: '0 0 57%' }}>
                          <Button
                            text="Verify Via Link"
                            btnStyle="primary-light-outline"
                            onClick={() => {
                              setAuthAction('link');
                              selectedMethod === 'whatsapp'
                                ? handleSendOtp(values, 3)
                                : handleSubmit();
                            }}
                            className="h-35 w-100"
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="d-flex gap-3 mb-5 w-100">
                        <div style={{ flex: '0 0 40%' }}>
                          <Button
                            text="GMAIL"
                            btnStyle="primary-light-outline"
                            icon={
                              <span className="cme-10">
                                <img
                                  src={icons.gmailSquare}
                                  height={16}
                                  width={16}
                                />
                              </span>
                            }
                            onClick={async () => {
                              const isValid = await props.validateForm();
                              if (Object.keys(isValid).length === 0) {
                                handleSelectMethod('gmail', setFieldValue);
                              } else {
                                props.setTouched({ email: true });
                              }
                            }}
                            disabled={otpLoader}
                            btnLoading={otpLoader}
                            className="h-35 w-100 text-14-500-18"
                          />
                        </div>
                        <div style={{ flex: '0 0 57%' }}>
                          <Button
                            text="Whatsapp"
                            btnStyle="primary-whatsapp-outline"
                            icon={
                              <span className="cme-10">
                                <img
                                  src={icons.whatsAppChat}
                                  height={16}
                                  width={16}
                                />
                              </span>
                            }
                            onClick={async () => {
                              const isValid = await props.validateForm();
                              if (Object.keys(isValid).length === 0) {
                                handleSelectMethod('whatsapp', setFieldValue);
                              } else {
                                props.setTouched({ email: true });
                              }
                            }}
                            className="h-35 w-100 text-14-500-18"
                          />
                        </div>
                      </div>
                    )}

                    {params?.type !== 'admin' && (
                      <>
                        <LineTextLabel text="OR" />
                        <div className="mt-4 mb-4">
                          <Button
                            isRounded
                            text="Continue with Google"
                            btnStyle="light-outline"
                            onClick={() => {
                              login();
                            }}
                            btnLoading={isGoggleBtnLoad}
                            icon={
                              <img
                                src={icons.googleLogo}
                                alt="google"
                                className="pe-2"
                              />
                            }
                          />
                        </div>
                        <div className="text-center">
                          <span className="text-14-400">New to IFERP?</span>
                          <span
                            className="text-14-500 color-new-car underline ps-2 pointer"
                            onClick={() => {
                              navigate('/member/register');
                            }}
                          >
                            <u>Register Now</u>
                          </span>
                        </div>
                      </>
                    )}
                  </form>
                );
              }}
            </Formik>
          )}
          {formType === 1 && (
            <Formik
              initialValues={{}}
              onSubmit={() => {
                handelVerifyOTP();
              }}
            >
              {(props) => {
                const { handleSubmit } = props;
                return (
                  <form
                    onSubmit={handleSubmit}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        handleSubmit();
                      }
                    }}
                  >
                    <div className="text-15-400 color-black-olive mb-5 text-center">
                      {selectedMethod === 'whatsapp' ? (
                        <>
                          A One-Time Passcode has been sent to your registered
                          WhatsApp Number{' '}
                          <span className="text-15-500 color-raisin-black ms-1">
                            {getCountryCode(whatsappData?.country_code || 'IN')}{' '}
                            {whatsappData?.whatsapp_number}
                          </span>
                        </>
                      ) : (
                        <>
                          A One-Time Passcode has been sent to your registered
                          email{' '}
                          <span className="text-15-500 color-raisin-black ms-1">
                            {emailId}
                          </span>
                        </>
                      )}
                    </div>
                    <div className="center-flex flex-column">
                      <Label
                        label="Enter One-time Passcode"
                        className="cmb-24"
                      />
                      <InputOTP
                        blockSize={4}
                        resetOTP={resetOTP}
                        onSubmit={handleOtp}
                        setResetOTP={setResetOTP}
                        isDisableTyping={loadButton || otpLoader}
                      />
                      {/* <div className="text-14-400 color-black-olive mt-3 mb-5 d-flex align-items-center">
                        If you didn’t receive a code!{" "}
                        <span
                          className="text-16-400 color-new-car pointer ms-2"
                          onClick={() => {
                            handelSendOTP({ email: emailId });
                          }}
                        >
                          {otpLoader ? <Loader size="sm" /> : "Resend"}
                        </span>
                      </div> */}
                    </div>
                    <div className="mt-5 mb-4">
                      {isOTPSent && (
                        <div className="text-center text-14-400">OTP sent!</div>
                      )}
                      {counter === 0 ? (
                        <div className="d-flex justify-content-center align-items-center gap-3">
                          <Button
                            className="ps-3 pe-3 h-35 text-14-400"
                            text="Resend OTP"
                            btnStyle="primary-outline"
                            onClick={() => {
                              handelSendOTP(
                                selectedMethod === 'whatsapp'
                                  ? {
                                    whatsapp_number:
                                      whatsappData?.whatsapp_number,
                                    country_code: whatsappData?.country_code,
                                    email: whatsappData?.email,
                                  }
                                  : { email: emailId }
                              );
                            }}
                            btnLoading={otpLoader}
                            disabled={otpLoader}
                          />
                          <span className="text-14-500">or</span>
                          <div
                            className="text-14-500 pointer color-new-car verify-link"
                            onClick={() => setFormType(3)}
                          >
                            Verify Via Link
                          </div>
                        </div>
                      ) : (
                        <div className="text-center text-16-400 mt-2">
                          You can resend the OTP in
                          <span className="color-new-car text-16-500">{` ${formatTime(counter)}`}</span>
                        </div>
                      )}
                    </div>
                    <div className="mb-2 pt-3">
                      <Button
                        isRounded
                        text="Verify Email"
                        btnStyle="primary-dark"
                        onClick={handelVerifyOTP}
                        disabled={
                          loadButton ||
                          otpLoader ||
                          !otp ||
                          (otp && otp.length !== 4)
                        }
                        btnLoading={loadButton}
                      />
                    </div>
                  </form>
                );
              }}
            </Formik>
          )}
          {formType === 2 && (
            <Formik
              enableReinitialize
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(values) => {
                handelChangePassword(values);
              }}
            >
              {(props) => {
                const { values, errors, handleChange, handleSubmit } = props;
                return (
                  <form
                    onSubmit={handleSubmit}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        handleSubmit();
                      }
                    }}
                  >
                    <div className="cmb-30 pt-3">
                      <PasswordInput
                        labelClass="mb-2"
                        id="new_password"
                        label="New Password"
                        placeholder="Enter New Password"
                        onChange={handleChange}
                        value={values.new_password}
                        error={errors.new_password}
                        isShowSuggetion
                      />
                    </div>
                    <div>
                      <PasswordInput
                        labelClass="mb-2"
                        id="confirm_password"
                        label="Confirm New Password"
                        placeholder="Confirm New Password"
                        onChange={handleChange}
                        value={values.confirm_password}
                        error={errors.confirm_password}
                      />
                    </div>

                    <div className="mt-5">
                      <Button
                        isRounded
                        text="Submit"
                        btnStyle="primary-dark"
                        onClick={handleSubmit}
                        disabled={loadButton}
                        btnLoading={loadButton}
                      />
                    </div>
                  </form>
                );
              }}
            </Formik>
          )}

          {formType === 3 && (
            <div className="flex flex-col items-center justify-center text-center">
              <div className="text-15-400 color-black-olive cmb-24">
                <span className="text-15-500 color-raisin-black">
                  {emailId}
                </span>
              </div>
              <div className="text-14-400 color-1717 cmb-24">
                {`We will send a password reset link to your registered ${selectedMethod === 'whatsapp'
                  ? 'WhatsApp number'
                  : 'email address'
                  }`}
              </div>

              <div className="d-flex justify-content-center gap-2">
                <Button
                  text="Submit"
                  btnStyle="primary-dark"
                  className="h-35 cps-20 cpe-20"
                  onClick={handleVerifyLink}
                  disabled={verifyLoader}
                  btnLoading={verifyLoader}
                />
                <Button
                  text="Cancel"
                  btnStyle="light-outline"
                  className="h-35 cps-20 cpe-20"
                  disabled={verifyLoader}
                  onClick={() => setFormType(0)}
                />
              </div>
            </div>
          )}

          {/* Show WhatsApp OTP Number and send otp */}
          {formType === 4 && (
            <div className="flex flex-col items-center justify-center text-center">
              <div className="text-15-400 color-black-olive cmb-24">
                <span className="text-15-500 color-raisin-black">
                  {getCountryCode(whatsappData?.country_code || 'IN')}{' '}
                  {whatsappData?.whatsapp_number}
                </span>
              </div>
              <div className="text-14-400 color-1717 cmb-24">
                We will send a OTP to your registered WhatsApp Number
              </div>

              <div className="d-flex justify-content-center gap-2">
                <Button
                  text="Submit"
                  btnStyle="primary-dark"
                  className="h-35 cps-20 cpe-20"
                  onClick={() => handelWhatsappSendOTP(whatsappData)}
                  disabled={otpLoader}
                  btnLoading={otpLoader}
                />
                <Button
                  text="Cancel"
                  btnStyle="light-outline"
                  className="h-35 cps-20 cpe-20"
                  disabled={otpLoader}
                  onClick={() => setFormType(0)}
                />
              </div>
            </div>
          )}
        </Card>
      </div>
    </HeaderLayout>
  );
};
export default ForgotPassword;
